var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"open-dialog-link",attrs:{"href":"javascript:;"},on:{"click":_vm.clickHandle}},[_vm._v(_vm._s(_vm.name))])
}
var staticRenderFns = []

export { render, staticRenderFns }